import { Component, OnDestroy, OnInit } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { PageResponse } from 'src/app/interfaces/page-response.interface';
import { ProyectoDepurar } from 'src/app/interfaces/proyecto-depurar.interface';
import { HomePathService } from 'src/app/services/home-path.service';
import { BandejaService } from 'src/app/services/bandeja.service';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-solicitudes-depurar',
  templateUrl: './solicitudes-depurar.component.html',
  styleUrls: ['./solicitudes-despurar.component.css']
})
export class SolicitudesDepurarComponent implements OnInit, OnDestroy {

  private autoRefreshSub?: Subscription;

  homePath: string;
  es: any;
  content: ProyectoDepurar[];
  totalRecords: number;
  cols: any[];
  rows: number;
  first: number;
  currentPage: number;

  loading: boolean;
  fechaDepIni: Date | null;
  fechaDepFin: Date | null;
  minFechaHistorica: Date;
  maxFechaHoy: Date;
  displayEditModal: boolean;
  proyectoSeleccionado: ProyectoDepurar | null;
  savingEdit: boolean;
  filtroNomProyecto: string;
  filtroFolio: string;
  private ultimoFiltroNomProyecto: string;
  private ultimoFiltroFolio: string;

  constructor(
    private homePathService: HomePathService,
    private messageService: MessageService,
    private bandejaService: BandejaService
  ) {
    this.homePath = this.homePathService.getHomePath();
    this.content = [];
    this.totalRecords = 0;
    this.cols = [];
    this.rows = 10;
    this.first = 0;
    this.currentPage = 0;
    this.loading = false;
    this.fechaDepIni = null;
    this.fechaDepFin = null;
    this.maxFechaHoy = new Date();
    this.minFechaHistorica = new Date();
    this.minFechaHistorica.setFullYear(this.maxFechaHoy.getFullYear() - 8);
    this.displayEditModal = false;
    this.proyectoSeleccionado = null;
    this.savingEdit = false;
    this.filtroNomProyecto = '';
    this.filtroFolio = '';
    this.ultimoFiltroNomProyecto = '';
    this.ultimoFiltroFolio = '';
  }

  ngOnInit() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Limpiar',
      dateFormat: 'dd/mm/yy'
    };
    this.cols = [
      { field: 'cveProyecto', header: 'Clave proyecto' },
      { field: 'nomProyecto', header: 'Nombre del proyecto' },
      { field: 'folio', header: 'Folio' },
      { field: 'estatusDescripcion', header: 'Estatus' },
      { field: 'retencion', header: 'Retención', format: 'boolean' },
      { field: 'motivoRetencion', header: 'Motivo retención' },
      { field: 'fechaDepuracion', header: 'Fecha depuración', format: 'date' },
      { field: 'fechaUltMod', header: 'Fecha última modificación', format: 'date' }
    ];
    this.autoRefreshSub = timer(60_000, 60_000).subscribe(() => {
      this.cargarSolicitudesDepurar(this.currentPage, this.rows, false);
    });
    this.cargarSolicitudesDepurar(this.currentPage, this.rows);
  }

  ngOnDestroy(): void {
    if (this.autoRefreshSub) {
      this.autoRefreshSub.unsubscribe();
    }
  }

  onFechaFiltroChange() {
    if (this.fechaDepIni && this.fechaDepFin && this.fechaDepFin < this.fechaDepIni) {
      this.fechaDepFin = this.fechaDepIni;
    }
    this.first = 0;
    this.currentPage = 0;
    this.cargarSolicitudesDepurar(0, this.rows);
  }

  limpiarFechas() {
    this.fechaDepIni = null;
    this.fechaDepFin = null;
    this.first = 0;
    this.currentPage = 0;
    this.cargarSolicitudesDepurar(0, this.rows);
  }

  aplicarFiltros() {
    this.ultimoFiltroNomProyecto = this.normalizarFiltro(this.filtroNomProyecto);
    this.ultimoFiltroFolio = this.normalizarFiltro(this.filtroFolio);
    this.first = 0;
    this.currentPage = 0;
    this.cargarSolicitudesDepurar(0, this.rows);
  }

  onFiltroTextoChange(campo: 'nomProyecto' | 'folio') {
    const valorActual = campo === 'nomProyecto'
      ? this.normalizarFiltro(this.filtroNomProyecto)
      : this.normalizarFiltro(this.filtroFolio);

    const ultimoValor = campo === 'nomProyecto'
      ? this.ultimoFiltroNomProyecto
      : this.ultimoFiltroFolio;

    if (valorActual === ultimoValor) {
      return;
    }

    if (valorActual.length === 0 || valorActual.length >= 3) {
      this.aplicarFiltros();
    }
  }

  limpiarFiltros() {
    this.filtroNomProyecto = '';
    this.filtroFolio = '';
    this.aplicarFiltros();
  }

  loadLazy(event: LazyLoadEvent) {
    const rows = event.rows || this.rows;
    const first = event.first || 0;
    const page = Math.floor(first / rows);
    this.rows = rows;
    this.first = first;
    this.currentPage = page;
    this.cargarSolicitudesDepurar(page, rows);
  }

  abrirModalEdicion(proyecto: ProyectoDepurar) {
    this.proyectoSeleccionado = { ...proyecto };
    this.displayEditModal = true;
  }

  cerrarModalEdicion() {
    if (this.savingEdit) {
      return;
    }

    this.displayEditModal = false;
    this.proyectoSeleccionado = null;
  }

  guardarEdicion() {
    if (!this.proyectoSeleccionado) {
      return;
    }

    this.savingEdit = true;
    this.bandejaService.actualizarRetencionProyecto(this.proyectoSeleccionado).subscribe(
      () => {
        this.savingEdit = false;
        this.displayEditModal = false;
        this.proyectoSeleccionado = null;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado correctamente.' });
        this.cargarSolicitudesDepurar(this.currentPage, this.rows, false);
      },
      error => {
        console.error('Error al actualizar retención--->', error);
        this.savingEdit = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No fue posible actualizar el registro.', life: 6000 });
      }
    );
  }

  private cargarSolicitudesDepurar(page: number, size: number, showMessage: boolean = false) {
    this.loading = true;
    this.bandejaService.getSolicitudesDepurar(
      page,
      size,
      8,
      this.formatearFecha(this.fechaDepIni),
      this.formatearFecha(this.fechaDepFin),
      this.filtroNomProyecto,
      this.filtroFolio
    ).subscribe(
      (data: PageResponse<ProyectoDepurar>) => {
        this.content = data.content || [];
        this.totalRecords = data.totalElements || 0;
        this.rows = data.size || size;
        this.currentPage = data.number || page;
        this.first = this.currentPage * this.rows;
        this.loading = false;
        if (showMessage) {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Consulta realizada correctamente.' });
        }
      },
      error => {
        console.error('Error--->', error);
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No fue posible consultar los proyectos a depurar.', life: 6000 });
      }
    );
  }

  private formatearFecha(fecha: Date | null): string | undefined {
    if (!fecha) {
      return undefined;
    }

    const year = fecha.getFullYear();
    const month = `${fecha.getMonth() + 1}`.padStart(2, '0');
    const day = `${fecha.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private normalizarFiltro(valor: string): string {
    return (valor || '').trim();
  }
}
